import { render } from "./WeekSliderSlide.vue?vue&type=template&id=4cfa7dbe"
import script from "./WeekSliderSlide.vue?vue&type=script&lang=js"
export * from "./WeekSliderSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__